import pkg from './package.json';
import {ASSET_CDN_DOMAIN} from '@udemy-v2/nextjs-core';
import {ICON_SPRITEMAP_JS} from '@udemy-v2/icons';

const APP_NAME = pkg.name;
const DEPLOY_ENV = process.env.DEPLOY_ENV || 'local';
const PORT = process.env.PORT || '8080';

const appBasePath = {
    local: '/',
    dev: '/',
    prod: '/',
};

const assetPrefixMap = {
    local: `/${APP_NAME}/`,
    dev: `https://${ASSET_CDN_DOMAIN.dev}/${APP_NAME}`,
    prod: `https://${ASSET_CDN_DOMAIN.prod}/${APP_NAME}`,
};

// Should match values defined in https://udemycom.sentry.io/settings/projects/${APP_NAME}/keys/
const sentryDSN = {
    // Override Sentry DSN values per environment (local, dev, prod) below
    // <<Stencil::Block(sentryDSNs)>>
    local: 'https://fc92fc5140390943a8cbe249eca62214@o15335.ingest.us.sentry.io/4509242803421185',
    dev: 'https://fc92fc5140390943a8cbe249eca62214@o15335.ingest.us.sentry.io/4509242803421185',
    prod: 'https://fc92fc5140390943a8cbe249eca62214@o15335.ingest.us.sentry.io/4509242803421185',
    // <</Stencil::Block>>
};

const APP_BASE_PATH = appBasePath[DEPLOY_ENV as keyof typeof appBasePath];
const ASSET_PREFIX =
    process.env.ASSET_PREFIX || assetPrefixMap[DEPLOY_ENV as keyof typeof assetPrefixMap];
const SENTRY_DSN = process.env.SENTRY_DSN ?? sentryDSN[DEPLOY_ENV as keyof typeof sentryDSN];
const SVG_SPRITEMAP_JS = ICON_SPRITEMAP_JS[DEPLOY_ENV as keyof typeof ICON_SPRITEMAP_JS];

const VERSION = process.env.VERSION ? process.env.VERSION.slice(0, 7) : 'latest';

export const env = {
    APP_BASE_PATH,
    APP_NAME,
    ASSET_PREFIX,
    DEPLOY_ENV,
    PORT,
    SENTRY_DSN,
    SVG_SPRITEMAP_JS,
    VERSION,
};
